module.exports = __webpack_public_path__ + "static/media/Coi-Hero-Banner-world-map.c8261b51.jpg";